import styled from "styled-components";

export const MapContainer = styled.div`
  position: relative;
  height: 100vh;

  .fleet-car-msg-window {
    right: 0;
    left: 0;
    z-index: 1;
    margin: 0 auto;
    position: absolute;
    max-width: 300px;
    top: 49px;
  }
  .active {
    background: #bc9b6a !important;
    color: white !important;
  }
  @media (max-width: 786px) {
    height: calc(100vh - 56px);
  }
`;

export const SiteSettingModalContainer = styled.div`
  min-width: 243px;
  background: rgba(255, 255, 255, 0.8);
  /* border: 1px solid #040707;
  border-radius: 6px; */
  .MuiDialogActions-root {
    justify-content: center;
  }
  .MuiDialogContent-root {
    padding: 0 13px;
  }
  .MuiDialogContentText-root {
    font-family: "Roboto";
    margin-bottom: 3px;
    font-size: 16px;
    line-height: 23px;
  }
  .MuiFormControl-root {
    margin-bottom: 15px;
  }
  .MuiSelect-select {
    padding: 3.5px 14px;
    font-size: 13px;
    background-color: #fff;
  }
  .MuiDialogTitle-root {
    font-family: "Roboto";
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    background-color: #fff;
    padding: 13px 13px 6px;
    margin-bottom: 17px;
  }
`;

export const FilterHeader = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  z-index: 1;
  top: 20px;
  padding-right: 20px;
  gap: 10px;
  justify-content: flex-end;
    left: unset;
    width: auto;
  .setting-icon {
    width: 41px;
    height: 32px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    cursor: pointer;
  }
  .tags {
    color: #2d2424;
    font-size: 14px;
    height: 30px;
    /* background: #82dbcf; */
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px;
    display: inline-flex;
    min-width: 60px;
    padding: 0 10px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: none;
  }
  @media (max-width: 850px) {
    padding: 0;
    top: 0;
    width: 100%;
    .display {
      display: none;
    }
  }
`;

export const TagsWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 10px;
  border: none;
  width: auto;
    position: absolute;
    transform: translate(-40vw,0);
  @media (max-width: 1392px) {
    transform: translate(-19vw,0);
  }
`;

export const BottomWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 10px;
  border: none;
  width: auto;
    position: relative;
    transform: translate(-50vw,600px);
    .divStyle{
    display: flex;
    gap: 10px;
    background-color: lightgray;
    padding: 3px;
    width: 400px;
    height: 35px;
    }
    .input{
    width:105px;
    }
    .tags {
    color: #2d2424;
    font-size: 14px;
    height: 30px;
    /* background: #82dbcf; */
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px;
    display: inline-flex;
    min-width: 60px;
    padding: 0 10px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: none;
  }
  @media (max-width: 1392px) {
    transform: translate(-19vw,0);
  }
`;

export const TimeWrapper = styled.div`
  display: flex;
  gap: 10px;
  .time-tag {
    display: flex;
    align-items: center;
    padding: 0 10px;
    gap: 10px;
    min-height: 31px;
    border: none;
    background: #fffffff2;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    border-radius: 6px;
  }
  > div {
    font-size: 14px;
    color: #989c9e;
    background: #fffffff2;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px;
    span {
      font-family: "latobold";
      color: #000;
    }
  }
`;

export const TagsTitle = styled.div`
  gap: 10px;
  color: #00000099;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  font-weight: 400;
`;

export const DailogMain = styled.div`
  background: white;
  overflow: auto;
`;

export const Area = styled.div`
  padding-right: 10px;
`;
